import { Shield, Clock, Award, DollarSign, Users } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';

const AboutSection = () => {
  const { language } = useLanguage();
  const t = translations[language].about;
  
  const features = [
    {
      icon: Clock,
      title: t.features.fast.title,
      description: t.features.fast.description
    },
    {
      icon: Shield,
      title: t.features.reliable.title,
      description: t.features.reliable.description
    },
    {
      icon: Award,
      title: t.features.quality.title,
      description: t.features.quality.description
    },
    {
      icon: DollarSign,
      title: t.features.pricing.title,
      description: t.features.pricing.description
    },
    {
      icon: Users,
      title: t.features.team.title,
      description: t.features.team.description
    }
  ];

  return (
    <section id="rolunk" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#7B2F3D] font-semibold text-sm uppercase tracking-widest">{t.badge}</span>
          <h2 className="text-4xl font-bold mt-3 text-gray-900">
            {t.title}
          </h2>
          <p className="text-gray-600 mt-4 leading-relaxed">
            {t.description1}
          </p>
          <p className="text-gray-600 mt-4 leading-relaxed">
            {t.description2}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature) => (
            <div key={feature.title} className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-[#7B2F3D]/10 flex items-center justify-center">
                <feature.icon className="w-6 h-6 text-[#7B2F3D]" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;